import { useRouter } from 'next/router';
import { Person, Business, Public } from '@mui/icons-material';

import {
  ToggleButton, ToggleButtonGroup, Tooltip,
} from '@mui/material';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import { USER_TYPES } from 'lib/constants';
import { CreatorType } from 'lib/types/filters';

interface Props {
  defaultType: CreatorType;
  selected?: CreatorType;
}

export const CreatorTypeFilter = ({
  defaultType,
  selected,
}: Props) => {
  const router = useRouter();
  const listOrTeamSelected = !!router.query.list || !!router.query.teamId;

  const onChange = (userType: string) => {
    if (listOrTeamSelected) {
      // If a list is active then the default is all (creators + companies)
      if (userType === USER_TYPES.all.key || !userType) {
        updateRouterQuery(router, { userType: [] });
      } else {
        updateRouterQuery(router, { userType });
      }
      return;
    }

    // If a list is *not* active then the default is creators only.
    if (userType === defaultType) {
      updateRouterQuery(router, { userType: [] });
    } else {
      updateRouterQuery(router, { userType });
    }
  };

  const value = selected || (listOrTeamSelected ? USER_TYPES.all.key : defaultType);

  return (

    <Tooltip title="Display creators or companies" placement="top" arrow>
      <ToggleButtonGroup
        value={value}
        onChange={(_, v) => onChange(v)}
        aria-label="creators or companies"
        exclusive
      >
        <ToggleButton value={USER_TYPES.creator.key} aria-label="creators" size="small">
          <Person />
        </ToggleButton>

        <ToggleButton value={USER_TYPES.company.key} aria-label="companies" size="small">
          <Business />
        </ToggleButton>

        <ToggleButton value={USER_TYPES.all.key} aria-label="all" size="small">
          <Public />
        </ToggleButton>

      </ToggleButtonGroup>
    </Tooltip>

  );
};
